




















import { ExternalChatResponse } from '@/api/types'
import { Component, Vue } from 'vue-property-decorator'
import { fetchExternalChat } from '@/api'
import { invoke } from 'wecom-sidebar-jssdk'
import { message } from 'ant-design-vue'

@Component({
  name: 'ExternalChat'
})
export default class ExternalChat extends Vue {
  externalChat: ExternalChatResponse['group_chat'] | null = null;

  async openUserProfile (userId: string, type: 1 | 2) {
    try {
      await invoke('openUserProfile', {
        userid: userId,
        type
      })
    } catch (e) {
      message.error(e.message)
    }
  }

  async getExternalChatInfo () {
    try {
      const res = await invoke('getCurExternalChat', {})

      if (!res || !res.chatId) return

      console.log('外部联系群 ID', res.chatId)

      this.externalChat = await fetchExternalChat(res.chatId || '')
    } catch (e) {
      message.error(e.message)
    }
  }

  async mounted () {
    await this.getExternalChatInfo()
  }
}
